function toVisualSeed(value: string) {
  let hash = 2166136261
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return hash >>> 0
}

function createVisualRandom(seed: number) {
  let state = Math.imul(seed ^ (seed >>> 15), 2246822507) >>> 0
  return () => {
    state = (state * 1664525 + 1013904223) >>> 0
    return state / 4294967296
  }
}

export { createVisualRandom, toVisualSeed }
